
export const FIELD_TYPES = {
  STRING: 1,
  INTEGER: 2,
  PHONE: 3,
  EMAIL: 4,
  INSTAGRAM: 5,
  FACEBOOK: 6,
  LINKEDIN: 7,
  URL: 8,
  TWITTER: 9,
  WHATSAPP: 10,
  YOUTUBE: 11,
  DATE: 12,
  DATETIME: 13,
  SKYPE: 14,
  SLACK: 15,
  PERCENTAGE: 16,
  TIME: 17,
  CURRENCY: 18,
  TEXTAREA: 19,
  DECIMAL: 20,
  IMAGE: 21,
  PHOTO: 22,
  BOOLEAN: 23,
  PICKLIST: 24,
  RELATED_TO_A_MODULE: 25,
  FORMULA: 26,
  MAP: 27,
  DOCUMENT: 28,
  BADGE: 29,
  RELATED_TO_KANBAN: 30,
  TABLE: 31,
  MULTIPLE_LIST: 32,
  RELATED_TO_A_MODULE_MULTIPLE: 33,
  PUSH_TAGS_LIST: 34,
  MULTIPLE_DATE: 35,
  EMBBEDED: 36,
  MULTIPLE_DOCUMENTS: 37,
  RELATED_TO_A_USER: 38,
  COLOR: 39,
  RICHTEXT: 40
}

export const ICONS = [
  'ActivityIcon',
  'AirplayIcon',
  'AlertCircleIcon',
  'AlertOctagonIcon',
  'AlertTriangleIcon',
  'AlignCenterIcon',
  'AlignJustifyIcon',
  'AlignLeftIcon',
  'AlignRightIcon',
  'AnchorIcon',
  'ApertureIcon',
  'ArchiveIcon',
  'ArrowDownCircleIcon',
  'ArrowDownLeftIcon',
  'ArrowDownRightIcon',
  'ArrowDownIcon',
  'ArrowLeftCircleIcon',
  'ArrowLeftIcon',
  'ArrowRightCircleIcon',
  'ArrowRightIcon',
  'ArrowUpCircleIcon',
  'ArrowUpLeftIcon',
  'ArrowUpRightIcon',
  'ArrowUpIcon',
  'AtSignIcon',
  'AwardIcon',
  'BarChart2Icon',
  'BarChartIcon',
  'BatteryChargingIcon',
  'BatteryIcon',
  'BellOffIcon',
  'BellIcon',
  'BluetoothIcon',
  'BoldIcon',
  'BookOpenIcon',
  'BookIcon',
  'BookmarkIcon',
  'BoxIcon',
  'BriefcaseIcon',
  'CalendarIcon',
  'CameraOffIcon',
  'CameraIcon',
  'CastIcon',
  'CheckCircleIcon',
  'CheckSquareIcon',
  'CheckIcon',
  'ChevronDownIcon',
  'ChevronLeftIcon',
  'ChevronRightIcon',
  'ChevronUpIcon',
  'ChevronsDownIcon',
  'ChevronsLeftIcon',
  'ChevronsRightIcon',
  'ChevronsUpIcon',
  'ChromeIcon',
  'CircleIcon',
  'ClipboardIcon',
  'ClockIcon',
  'CloudDrizzleIcon',
  'CloudLightningIcon',
  'CloudOffIcon',
  'CloudRainIcon',
  'CloudSnowIcon',
  'CloudIcon',
  'CodeIcon',
  'CodepenIcon',
  'CodesandboxIcon',
  'CoffeeIcon',
  'ColumnsIcon',
  'CommandIcon',
  'CompassIcon',
  'CopyIcon',
  'CornerDownLeftIcon',
  'CornerDownRightIcon',
  'CornerLeftDownIcon',
  'CornerLeftUpIcon',
  'CornerRightDownIcon',
  'CornerRightUpIcon',
  'CornerUpLeftIcon',
  'CornerUpRightIcon',
  'CpuIcon',
  'CreditCardIcon',
  'CropIcon',
  'CrosshairIcon',
  'DatabaseIcon',
  'DeleteIcon',
  'DiscIcon',
  'DivideCircleIcon',
  'DivideSquareIcon',
  'DivideIcon',
  'DollarSignIcon',
  'DownloadCloudIcon',
  'DownloadIcon',
  'DribbbleIcon',
  'DropletIcon',
  'Edit2Icon',
  'Edit3Icon',
  'EditIcon',
  'ExternalLinkIcon',
  'EyeOffIcon',
  'EyeIcon',
  'FacebookIcon',
  'FastForwardIcon',
  'FeatherIcon',
  'FigmaIcon',
  'FileMinusIcon',
  'FilePlusIcon',
  'FileTextIcon',
  'FileIcon',
  'FilmIcon',
  'FilterIcon',
  'FlagIcon',
  'FolderMinusIcon',
  'FolderPlusIcon',
  'FolderIcon',
  'FramerIcon',
  'FrownIcon',
  'GiftIcon',
  'GitBranchIcon',
  'GitCommitIcon',
  'GitMergeIcon',
  'GitPullRequestIcon',
  'GithubIcon',
  'GitlabIcon',
  'GlobeIcon',
  'GridIcon',
  'HardDriveIcon',
  'HashIcon',
  'HeadphonesIcon',
  'HeartIcon',
  'HelpCircleIcon',
  'HexagonIcon',
  'HomeIcon',
  'ImageIcon',
  'InboxIcon',
  'InfoIcon',
  'InstagramIcon',
  'ItalicIcon',
  'KeyIcon',
  'LayersIcon',
  'LayoutIcon',
  'LifeBuoyIcon',
  'Link2Icon',
  'LinkIcon',
  'LinkedinIcon',
  'ListIcon',
  'LoaderIcon',
  'LockIcon',
  'LogInIcon',
  'LogOutIcon',
  'MailIcon',
  'MapPinIcon',
  'MapIcon',
  'Maximize2Icon',
  'MaximizeIcon',
  'MehIcon',
  'MenuIcon',
  'MessageCircleIcon',
  'MessageSquareIcon',
  'MicOffIcon',
  'MicIcon',
  'Minimize2Icon',
  'MinimizeIcon',
  'MinusCircleIcon',
  'MinusSquareIcon',
  'MinusIcon',
  'MonitorIcon',
  'MoonIcon',
  'MoreHorizontalIcon',
  'MoreVerticalIcon',
  'MousePointerIcon',
  'MoveIcon',
  'MusicIcon',
  'Navigation2Icon',
  'NavigationIcon',
  'OctagonIcon',
  'PackageIcon',
  'PaperclipIcon',
  'PauseCircleIcon',
  'PauseIcon',
  'PenToolIcon',
  'PercentIcon',
  'PhoneCallIcon',
  'PhoneForwardedIcon',
  'PhoneIncomingIcon',
  'PhoneMissedIcon',
  'PhoneOffIcon',
  'PhoneOutgoingIcon',
  'PhoneIcon',
  'PieChartIcon',
  'PlayCircleIcon',
  'PlayIcon',
  'PlusCircleIcon',
  'PlusSquareIcon',
  'PlusIcon',
  'PocketIcon',
  'PowerIcon',
  'PrinterIcon',
  'RadioIcon',
  'RefreshCcwIcon',
  'RefreshCwIcon',
  'RepeatIcon',
  'RewindIcon',
  'RotateCcwIcon',
  'RotateCwIcon',
  'RssIcon',
  'SaveIcon',
  'ScissorsIcon',
  'SearchIcon',
  'SendIcon',
  'ServerIcon',
  'SettingsIcon',
  'Share2Icon',
  'ShareIcon',
  'ShieldOffIcon',
  'ShieldIcon',
  'ShoppingBagIcon',
  'ShoppingCartIcon',
  'ShuffleIcon',
  'SidebarIcon',
  'SkipBackIcon',
  'SkipForwardIcon',
  'SlackIcon',
  'SlashIcon',
  'SlidersIcon',
  'SmartphoneIcon',
  'SmileIcon',
  'SpeakerIcon',
  'SquareIcon',
  'StarIcon',
  'StopCircleIcon',
  'SunIcon',
  'SunriseIcon',
  'SunsetIcon',
  'TabletIcon',
  'TagIcon',
  'TargetIcon',
  'TerminalIcon',
  'ThermometerIcon',
  'ThumbsDownIcon',
  'ThumbsUpIcon',
  'ToggleLeftIcon',
  'ToggleRightIcon',
  'ToolIcon',
  'Trash2Icon',
  'TrashIcon',
  'TrelloIcon',
  'TrendingDownIcon',
  'TrendingUpIcon',
  'TriangleIcon',
  'TruckIcon',
  'TvIcon',
  'TwitchIcon',
  'TwitterIcon',
  'TypeIcon',
  'UmbrellaIcon',
  'UnderlineIcon',
  'UnlockIcon',
  'UploadCloudIcon',
  'UploadIcon',
  'UserCheckIcon',
  'UserMinusIcon',
  'UserPlusIcon',
  'UserXIcon',
  'UserIcon',
  'UsersIcon',
  'VideoOffIcon',
  'VideoIcon',
  'VoicemailIcon',
  'Volume1Icon',
  'Volume2Icon',
  'VolumeXIcon',
  'VolumeIcon',
  'WatchIcon',
  'WifiOffIcon',
  'WifiIcon',
  'WindIcon',
  'XCircleIcon',
  'XOctagonIcon',
  'XSquareIcon',
  'XIcon',
  'YoutubeIcon',
  'ZapOffIcon',
  'ZapIcon',
  'ZoomInIcon',
  'ZoomOutIcon'
]


import CryptoJS from 'crypto-js'


export const resolveExternalMenuUrl = url => {
  if (!url || typeof url !== 'string' || !url.includes('$user_id')) {
    return url;
  }

  const user = getApplicationLocalStorageItem('user');
  if (!user) {
    return url;
  }

  try {
    return url.replace('$user_id', JSON.parse(user).hash);
  } catch (error) {
    return url;
  }
};

export const getApplicationLocalStorageItem = itemKey => {
  const localStorageObject = JSON.parse(
    localStorage.getItem(process.env.VUE_APP_LS_IDENTIFIER)
  )

  if (localStorageObject !== null) {
    if (localStorageObject.hasOwnProperty(itemKey)) {
      return localStorageObject[itemKey]
    } else {
      return null
    }
  } else {
    return null
  }
}

export const setApplicationLocalStorageItem = (itemKey, itemValue) => {
  let localStorageObject = JSON.parse(
    localStorage.getItem(process.env.VUE_APP_LS_IDENTIFIER)
  )

  if (localStorageObject === null) {
    localStorage.setItem(process.env.VUE_APP_LS_IDENTIFIER, {})
    localStorageObject = {}
  }

  localStorageObject[itemKey] = itemValue

  localStorage.setItem(
    process.env.VUE_APP_LS_IDENTIFIER,
    JSON.stringify(localStorageObject)
  )
}

export const removeApplicationLocalStorageItem = itemKey => {
  const localStorageObject = JSON.parse(
    localStorage.getItem(process.env.VUE_APP_LS_IDENTIFIER)
  )

  if (localStorageObject !== null) {
    if (localStorageObject.hasOwnProperty(itemKey)) {
      delete localStorageObject[itemKey]
    }
  }
}

export const performFetch = async (endpoint, body) => {

  try {
    let finalEndpoint = endpoint;
    if (finalEndpoint && !finalEndpoint.endsWith("/")) {
      const url = new URL(finalEndpoint);
      if (url.pathname === "" || url.pathname === "/") {
        finalEndpoint += "/";
      }
    }

    const response = await fetch(finalEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        ...body
        // application_token: store.state.auth.app_token, // Incluído globalmente
      })
    })

    return response
  } catch (e) {
    // Trate exceções de rede ou de parsing de JSON aqui.
    console.error('Fetch error:', e)
    throw e // Re-throw para que o chamador possa tratar o erro.
  }
}

export const decryptUuid = async (encryptedData) => {
  const base64Key = 'f1VaM29pxv24vmvE1V9D/Q=='
  const key = CryptoJS.enc.Base64.parse(base64Key)
  const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedData)

  // O IV é os primeiros 16 bytes
  const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4))
  const encrypted = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4))

  // Descriptografar
  const decrypted = CryptoJS.AES.decrypt({ ciphertext: encrypted }, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })

  return decrypted.toString(CryptoJS.enc.Utf8)
}

export const isValidHttpsUrl = (string) => {
  try {
    const url = new URL(string)
    return url.protocol === 'https:'
  } catch (error) {
    return false
  }
}


export const transformIconName = (str) => {
  let newStr = str.replace('Icon', '')
    .replace(/([A-Z0-9])/g, '-$1')   // Adiciona um "-" antes de cada letra maiúscula
    .toLowerCase()
  // const newStr = 'icon-' + str
  //   .toLowerCase()                // Converte para minúsculas
  //   .replace(/^-/, '');

  newStr = `icon${  newStr}`

  return newStr
}

export const isValidURL = (url) => {
  try {
    new URL(url)
    return true
  } catch (_) {
    return false
  }
}


export const objectChanges = (oldObj, newObj) => {
  const changes = {}

  // Pegar todas as chaves dos dois objetos
  const allKeys = new Set([...Object.keys(oldObj), ...Object.keys(newObj)])

  allKeys.forEach(key => {
    if (!Object.prototype.hasOwnProperty.call(oldObj, key)) {
      // Chave foi adicionada
      changes[key] = { old: undefined, new: newObj[key] }
    } else if (!Object.prototype.hasOwnProperty.call(newObj, key)) {
      // Chave foi removida
      changes[key] = { old: oldObj[key], new: undefined }
    } else if (oldObj[key] !== newObj[key]) {
      // Chave foi modificada
      changes[key] = { old: oldObj[key], new: newObj[key] }
    }
  })

  return changes
}


export const checkIfStringIsDateTime = (string) => {

  try {
    if ((string.split('-').length - 1) == 2 && (string.split(':').length - 1) == 2 && (string.split(' ').length - 1) == 1) {
      return true
    } else {
      return false
    }
  } catch (e) {
    return false
  }
}


export const checkIfStringIsDate = (string) => {
  try {
    if ((string.split('-').length - 1) == 2 && (string.length === 10)) {
      return true
    } else {
      return false
    }
  } catch (e) {
    return false
  }
}


export const buildQuickCreateFormData = (data) => {

}


export const USER_CUSTOM_FIELD_TYPES = ['select', 'select_multiple']

export const validateUserCustomField = (field) => {
  if (!('type' in field)) throw new Error('Tipo do campo não definido')
  if (!('name' in field)) throw new Error('Nome do campo não definido')
  if (!('label' in field)) throw new Error('Label não definida')
  if (!USER_CUSTOM_FIELD_TYPES.includes(field.type)) {
    throw new Error(`Tipo do campo inválido: ${field.type}`)
  }
  if (!('options' in field) || !Array.isArray(field.options)) {
    throw new Error('Opções inválidas ou não definidas')
  }
}

export const initUserCustomFieldModel = (field) => {
  if (field.type === 'select_multiple') {
    return field.options.filter(o => o.selected)
  }

  if (field.type === 'select') {
    return field.options.find(o => o.selected) || null
  }

  return null
}

export const buildUserCustomDataForSave = (customFields, customFieldsModel) => {
  const custom_data = {}

  customFields.forEach(field => {
    const value = customFieldsModel[field.name]

    if (field.type === 'select') {
      custom_data[field.name] = value
        ? { label: value.label, value: value.value }
        : null
      return
    }

    if (field.type === 'select_multiple') {
      custom_data[field.name] = (value || []).map(option => ({
        label: option.label,
        value: option.value
      }))
    }
  })

  return custom_data
}

export const getUserCustomFields = async (delegatorUrl, applicationToken, sessionToken, userHash = null) => {
  try {
    const response = await fetch(delegatorUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        command: 'get_user_custom_fields',
        application_token: applicationToken,
        session_token: sessionToken,
        user_hash: userHash
      })
    })

    if (!response.ok) {
      throw new Error('Network response was not ok')
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching user custom fields:', error)
    throw error
  }
}

/**
 * Calls the app api_delegator with command "on_login".
 * Returns true if the user was redirected to an external URL.
 * Fail-open: timeout, errors, or non-redirect responses return false.
 */
export const tryOnLoginDelegator = async ({
  delegatorUrl,
  applicationToken,
  sessionToken,
  user,
  timeoutMs = 2000
}) => {
  if (!delegatorUrl || !applicationToken || !sessionToken || !user) {
    return false
  }

  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
  const timeoutId = setTimeout(() => {
    if (controller) {
      controller.abort()
    }
  }, timeoutMs)

  try {
    const response = await fetch(delegatorUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      signal: controller ? controller.signal : undefined,
      body: JSON.stringify({
        command: 'on_login',
        application_token: applicationToken,
        session_token: sessionToken,
        user_hash: user.hash,
        username: user.username,
        email: user.email,
        name: user.name
      })
    })

    clearTimeout(timeoutId)

    if (!response.ok) {
      return false
    }

    const data = await response.json()
    const redirectUrl = data && data.url

    if (
      data &&
      data.redirect === true &&
      typeof redirectUrl === 'string' &&
      redirectUrl.startsWith('https://') &&
      isValidURL(redirectUrl)
    ) {
      window.location.href = redirectUrl
      return true
    }

    return false
  } catch (error) {
    clearTimeout(timeoutId)
    return false
  }
}
